var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ai-sales-content" },
    [
      _vm.hasPurchaseRecap
        ? _c(
            "dl",
            {
              staticClass: "ai-sales-content__purchase-recap",
              class: _vm.recapClass
            },
            _vm._l(_vm.formattedPurchaseRecap, function(yearlyRecap) {
              return _c(
                "div",
                {
                  key: yearlyRecap.year,
                  staticClass: "ai-sales-content__yearly-recap"
                },
                [
                  _c(
                    "dt",
                    {
                      staticClass:
                        "ai-sales-content__year typographies-paragraph-medium-regular"
                    },
                    [
                      _c("CompassIcon", {
                        attrs: { icon: "calendar", size: "small" }
                      }),
                      _vm._v(" " + _vm._s(yearlyRecap.year) + "\n            ")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "dd",
                    {
                      staticClass:
                        "ai-sales-content__yearly-amount typographies-paragraph-medium-semibold"
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$filters.numberFormatCurrency(
                              yearlyRecap.amount
                            )
                          ) +
                          "\n            "
                      )
                    ]
                  )
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasMargin
        ? _c(
            "AIContentList",
            {
              attrs: {
                hasMargin:
                  _vm.hasBestSellers ||
                  _vm.hasAveragePaymentTime ||
                  _vm.hasLatePayments
              }
            },
            [
              _c(
                "h4",
                { staticClass: "typographies-paragraph-medium-semibold" },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.$t.__(
                          "overview.tabs.TabSummary.salesContent.purchasing_trends"
                        )
                      ) +
                      "\n        "
                  )
                ]
              ),
              _vm._v(" "),
              _c("ul", [
                _vm.purchaseBehavior.average_purchase_frequency_per_year > 0
                  ? _c("li", [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$t.__(
                              "overview.tabs.TabSummary.salesContent.frequency"
                            )
                          ) +
                          " :\n                " +
                          _vm._s(_vm.formattedAverage) +
                          "\n                " +
                          _vm._s(
                            _vm.$t.n__(
                              "overview.tabs.TabSummary.salesContent.annual_purchases",
                              null,
                              _vm.purchaseBehavior
                                .average_purchase_frequency_per_year,
                              _vm.purchaseBehavior
                                .average_purchase_frequency_per_year
                            )
                          ) +
                          "\n            "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.purchaseBehavior.average_amount_per_purchase > 0
                  ? _c("li", [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$t.__(
                              "overview.tabs.TabSummary.salesContent.average_cart"
                            )
                          ) +
                          " :\n                " +
                          _vm._s(
                            _vm.$filters.numberFormatCurrency(
                              _vm.purchaseBehavior.average_amount_per_purchase
                            )
                          ) +
                          "\n            "
                      )
                    ])
                  : _vm._e()
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasBestSellers
        ? [
            _c(
              "AIContentList",
              {
                attrs: {
                  hasMargin: _vm.hasAveragePaymentTime || _vm.hasLatePayments
                }
              },
              [
                _c(
                  "h4",
                  { staticClass: "typographies-paragraph-medium-semibold" },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$t.__(
                            "overview.tabs.TabSummary.salesContent.best_selling_products"
                          )
                        ) +
                        "\n            "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "ul",
                  _vm._l(_vm.bestSellers.by_quantity, function(item) {
                    return _c("li", { key: item.id }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(item.name) +
                          " : " +
                          _vm._s(
                            _vm.getFormattedQuantity(item.total_quantity)
                          ) +
                          "\n                    " +
                          _vm._s(
                            _vm.$t.n__(
                              "common.labels.units",
                              null,
                              _vm.getFormattedQuantity(item.total_quantity),
                              _vm.getFormattedQuantity(item.total_quantity)
                            )
                          ) +
                          "\n                "
                      )
                    ])
                  }),
                  0
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "AIContentList",
              {
                attrs: {
                  hasMargin: _vm.hasAveragePaymentTime || _vm.hasLatePayments
                }
              },
              [
                _c(
                  "h4",
                  { staticClass: "typographies-paragraph-medium-semibold" },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$t.__(
                            "overview.tabs.TabSummary.salesContent.high_turnover_products"
                          )
                        ) +
                        "\n            "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "ul",
                  _vm._l(_vm.bestSellers.by_amount, function(item) {
                    return _c("li", { key: item.id }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(item.name) +
                          " : " +
                          _vm._s(
                            _vm.$filters.numberFormatCurrency(item.total_amount)
                          ) +
                          "\n                "
                      )
                    ])
                  }),
                  0
                )
              ]
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.hasAveragePaymentTime
        ? _c("p", { staticClass: "ai-document-content__payment-average" }, [
            _c(
              "span",
              { staticClass: "typographies-paragraph-medium-semibold" },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.$t.__(
                        "overview.tabs.TabSummary.paymentContent.average_payment"
                      )
                    ) +
                    " :\n        "
                )
              ]
            ),
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.$filters.numberFormatWithOptions(
                    _vm.financialRelationship.average_payment_time_days,
                    { precision: 0 },
                    false
                  )
                ) +
                "\n        " +
                _vm._s(_vm.$t.__("common.labels.days")) +
                "\n    "
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.hasLatePayments
        ? _c("p", { staticClass: "ai-document-content__late-payments" }, [
            _c(
              "span",
              { staticClass: "typographies-paragraph-medium-semibold" },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.$t.__(
                        "overview.tabs.TabSummary.paymentContent.late_payments"
                      )
                    ) +
                    " :\n        "
                )
              ]
            ),
            _vm._v(
              "\n        " +
                _vm._s(_vm.financialRelationship.late_payments_count) +
                "\n    "
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.hasNoData ? _c("NoInvoicingData") : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }